<template>
  <div id="mapContainer" ref="mapContainer"></div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import axios from "axios";
import pointsImg from "@/assets/images/pointImg.png";
import trangleSvg from "@/assets/images/trangle.svg";

export default {
  name: "map-component",
  props: {
    points: Array,
    default: () => [],
  },
  data() {
    return {
      dataForm: {
        kqName: undefined,
        kqLocation: undefined,
        kqLongitude: undefined,
        kqLatitude: undefined,
        kqWorkUnit: undefined,
        cronkqAccredit: [],
        kqValidCardRange: undefined,
      },
      input: "",
      AMap: null,
      map: null,
      auto: null,
      placeSearch: null,
      poiArr: [],
      lnglat: [],
      markers: [],
      position: {},
      infoWindow: null,
      zoom: null,
    };
  },
  mounted() {
    this.initAMap();
  },
  unmounted() {
    this.map?.destroy();
  },
  methods: {
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "eec63cd8b76159f07e80f82a0b4ebda2",
      };
      let centerLen = [118.379426, 24.704599];
      this.position = {
        longitude: centerLen[0],
        latitude: centerLen[1],
        address: "水头镇人民政府",
      };
      AMapLoader.load({
        key: "9fae248b096e4b114870421628dee578", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        // plugins: ["AMap.AutoComplete", "AMap.Geocoder"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.AMap = AMap;
          this.map = new AMap.Map("mapContainer", {
            // 设置地图容器id
            layers: [
              // 卫星
              new AMap.TileLayer.Satellite(),
              // 路网
              new AMap.TileLayer.RoadNet(),
            ],
            resizeEnable: true,
            viewMode: "3D", // 是否为3D地图模式
            zoom: 12.7, // 初始化地图级别
            center: centerLen, // 初始化地图中心点位置
          });

          this.drawPolygon();
          this.setMarker();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setMarker() {
      this.removeMarker();
      const icon = new this.AMap.Icon({
        size: new this.AMap.Size(28, 58), //图标尺寸
        image: pointsImg, //Icon 的图像
        imageOffset: new this.AMap.Pixel(0, 0), //图像相对展示区域的偏移量，适于雪碧图等
        imageSize: new this.AMap.Size(28, 58), //根据所设置的大小拉伸或压缩图片
      });
      let infoWindow = new this.AMap.InfoWindow({
        offset: new this.AMap.Pixel(2, -65),
        anchor: "bottom-center",
        isCustom: true, //使用自定义窗体
      });
      this.infoWindow = infoWindow;
      this.points.forEach(async (item) => {
        let marker = new this.AMap.Marker({
          position: [item.lng, item.lat],
          icon: icon,
          offset: new this.AMap.Pixel(2, 0),
          anchor: "bottom-center",
        });

        marker.content = this.createInfoWindow(item);

        // infoWindow.setContent(marker.content);
        // infoWindow.open(this.map, [item.lng, item.lat]);
        // 监听地图层级变化
        marker.on("mouseover", this.markerClick);
        marker.on("mouseout", this.markerClose);
        marker.on("click", () => {
          this.$emit("pointClick", item);
        });

        marker.setMap(this.map);
        this.markers.push(marker);
      });
    },
    markerClose() {
      let showPop = setTimeout(() => {
        this.infoWindow.close();
      }, 1000);
      let dom = document.getElementsByClassName("windowStyle")[0];
      if (dom) {
        dom.addEventListener("mouseover", () => {
          clearInterval(showPop);
        });

        dom.addEventListener("mouseout", () => {
          showPop = setTimeout(() => {
            this.infoWindow.close();
          }, 1000);
        });
      }
    },
    createInfoWindow(e) {
      var info = document.createElement("div");
      info.className = "windowStyle";
      info.style.filter =
        "drop-shadow(0 0 1px #2bd8fb) drop-shadow(0 0 1px #2bd8fb) drop-shadow(0 0 1px #2bd8fb)";
      // 定义中部内容
      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.style.padding = "6px 12px";
      middle.style.backgroundColor = "#061a4c";
      // middle.style.border = "1px solid #2bd8fb";
      const self = this; // 保存 this 引用

      const updateContent = () => {
        middle.innerHTML =
          `<div style="font-weight: bold;font-size: 16px">${e.qymc} <br/></div>` +
          `<span>${self.$t(
            "bigScreen.设备数"
          )}：</span><span style="font-size: 14px;color: #2BD8FB">${
            e.sl
          }</span>`;
      };

      // 初始设置内容
      updateContent();

      // 监听语言变化
      this.$watch("$i18n.locale", () => {
        updateContent();
      });

      info.appendChild(middle);

      // 定义底部内容
      var bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.display = "flex";
      bottom.style.justifyContent = "center";
      var sharp = document.createElement("img");
      sharp.src = trangleSvg;
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },

    markerClick(e) {
      this.infoWindow.setContent(e.target.content);
      this.infoWindow.open(this.map, e.target.getPosition());
    },

    async drawPolygon() {
      let path = [];
      await axios.get("/jsonData/stz.json").then((res) => {
        path = res.data.features[0].geometry.coordinates;
      });
      //创建多边形 Polygon 实例
      // eslint-disable-next-line
      var polygon = new this.AMap.Polygon({
        path: path, //路径
        fillColor: "#56FFFA", //多边形填充颜色
        strokeOpacity: 1, //线条透明度
        fillOpacity: 0.45, //填充透明度
        strokeColor: "#2b8cbe", //线条颜色
        strokeWeight: 1, //线条宽度
        strokeStyle: "dashed", //线样式
        strokeDasharray: [5, 5], //轮廓的虚线和间隙的样式
      });
      //多边形 Polygon对象添加到 Map
      this.map.add(polygon);
      // this.map.setFitView([polygon]);
    },

    removeMarker() {
      if (this.markers.length) {
        this.markers.forEach((marker) => {
          marker.setMap(null);
        });
        this.markers = [];
      }
    },
  },
  watch: {
    zoom(newVal) {
      this.zoom = newVal;
    },
    "$i18n.locale": {
      handler() {
        if (this.map) {
          this.setMarker();
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
#mapContainer {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
  position: relative;
}
.left {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
}
</style>
